import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { KbEntry } from "@shared/models/kb-entry"
import HasManyAltogether from "cc-frontend/helpers/has-many-altogether"
import type EmberStore from "cc-frontend/services/ember-store"
import { use } from "ember-could-get-used-to-this"
import { find } from "lodash-es"

interface Signature {
  Element: HTMLDivElement
  Args: {
    entry: KbEntry
  }
}

export default class KbBreadcrumbs extends Component<Signature> {
  @service("ember-store") declare store: EmberStore

  @use ancestors = new HasManyAltogether<KbEntry>(() => [this.args.entry, "ancestors", "kb-entry"])

  get home() {
    return find(this.ancestors.content, (ancestor) => {
      return ancestor.meta.type === "book"
    })
  }
}
